import { MediaMatcher } from '@angular/cdk/layout';
import {ChangeDetectorRef, Component, inject} from '@angular/core';
import { SideNavItem } from './interfaces/side-nav-item.interface';
import { MatDrawer, MatDrawerMode } from '@angular/material/sidenav';
import {
  AUDIT_ROUTE,
  BILLINGS_ROUTE, CONSOLE_ASHGRIDX_BASE_ROUTE,
  CONSOLE_ROUTE, CONSOLE_SURECHARGEX_BASE_ROUTE,
  SETTINGS_ROUTE,
  SITE,
  TEAM_MEMBERS_ROUTE,
} from '../../../aop-eop-core/src/app/constants/routes.constant';
import { MatDialog } from '@angular/material/dialog';
import { SwitchWorkspaceComponent } from './switch-workspace/switch-workspace.component';
import {WorkspaceService} from "./services/workspace.service";
import {IWorkspace} from "./interfaces/workspace.interface";
import {IUserProfile} from "../../../aop-eop-core/src/app/interfaces/i-user-profile.interface";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {goToSafePlaceLogin} from "./app-routing.module";
import {UserProfileService} from "../../../aop-eop-core/src/app/services/user-profile.service";
import {catchError, map, of} from "rxjs";
import {PROGRESS_BAR_SUBJECT} from "../../../aop-eop-core/src/app/app.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent {

}
